import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GameOverview from "../pages/game-overview/page";
import LevelSelector from "../pages/level-selector/page";
import MultiplicationChallenge from "../pages/multiplication-challenge/page";
import VolumeChallenge from "../pages/volume-challenge/page";
import DivisionChallenge from "../pages/division-challenge/page";
import OnlineGame from "../pages/online-game/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/game-overview",
    element: <GameOverview />,
  },
  {
    path: "/level-selector",
    element: <LevelSelector />,
  },
  {
    path: "/multiplication-challenge",
    element: <MultiplicationChallenge />,
  },
  {
    path: "/volume-challenge",
    element: <VolumeChallenge />,
  },
  {
    path: "/division-challenge",
    element: <DivisionChallenge />,
  },
  {
    path: "/online-game",
    element: <OnlineGame />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
